import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle";
import "rsuite/dist/rsuite.min.css";
import "./index.scss";
import { Provider } from "react-redux";
import { EvvAppStore } from "./core/redux";
import { SWRConfig } from "swr";
import { SwrGlobalConfig } from "./config/swrGlobalConfig";
import { ErrorBoundary } from "./components/errorBoundary";

ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Provider store={EvvAppStore}>
        <SWRConfig value={{ ...SwrGlobalConfig, provider: () => new Map() }}>
          <App />
        </SWRConfig>
      </Provider>
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
